import clsx from 'clsx';
import { observer } from 'mobx-react';
import * as React from 'react';
import Button from '../../../Form/Button';

interface Props {
  handleOnClick: () => void;
  disabled?: boolean;
}

const BackButton: React.FC<Props> = ({ handleOnClick, disabled }) => {
  return (
    <Button
      type="button"
      value="Back"
      className={clsx(
        'rounded-md border border-solid border-gray-900 bg-white',
        'px-5 py-2.5 text-sm font-semibold text-gray-900',
        'disabled:opacity-50',
      )}
      onClick={handleOnClick}
      disabled={disabled}
      intercomTarget="builder-back-button"
    />
  );
};

export default observer(BackButton);
